import { render, staticRenderFns } from "./GamesForPrizesList.vue?vue&type=template&id=b0816b76"
import script from "./GamesForPrizesList.vue?vue&type=script&lang=js"
export * from "./GamesForPrizesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports